import TrackingData from "./TrackingData";

/**
 * @class
 * @memberOf P3.tracking
 */
export default class TrackingDataGooglePageView extends TrackingData {
    /**
     * @param {string} page
     */
    constructor(page) {
        super();

        this.page = page;
    }
}